import { useTranslation } from "react-i18next"

import { lotsTotalBags, lotsTotalMT } from "@/features/transit/lib/ot-math"
import type { OT } from "@/features/transit/api/types"

interface HeaderStatsProps {
  ot: OT
}

// Compact inline stat strip used in the page header. Keeps Lots / Bags
// / Tonnage visible at a glance without taking the visual space of full
// KPI cards. The mismatch warnings (stuffed vs draft BL) are surfaced
// inside the Embarquement panel itself, so they don't appear here.
export function HeaderStats({ ot }: HeaderStatsProps) {
  const { t } = useTranslation("transit")
  const lots = ot.lots?.length ?? 0
  const bags = lotsTotalBags(ot)
  const mt = lotsTotalMT(ot)

  return (
    <div className="text-muted-foreground flex flex-wrap items-center justify-end gap-x-4 gap-y-1 text-xs">
      <Stat label={t("rollup.lots")} value={lots.toLocaleString()} />
      <Separator />
      <Stat label={t("rollup.bags")} value={bags.toLocaleString()} />
      <Separator />
      <Stat
        label={t("rollup.fromLots")}
        value={`${mt.toFixed(3)} MT`}
      />
    </div>
  )
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <span className="inline-flex items-baseline gap-1.5">
      <span className="text-[10px] font-medium uppercase tracking-wide">
        {label}
      </span>
      <span className="text-foreground text-sm font-medium tabular-nums">
        {value}
      </span>
    </span>
  )
}

function Separator() {
  return (
    <span aria-hidden className="text-muted-foreground/40">
      ·
    </span>
  )
}
